import httpClient from "./httpClient";
const classification = {
    getClassification() {
        return httpClient.get(`api/adv/profil/classification`)
            .then(response => {
                if (!response.success) return
                return response
            })
    },
    getDetailCondition(nuLevel, nuCondition) {
       
        return httpClient.get(`/api/adv-classification?nuLevel=${nuLevel}&nuCondition=${nuCondition}`)
    }
}

export default classification
